export default {
  getCampaign: (state) => (id) => {
    id = parseInt(id);
    if (state.campaigns && id) {
      return state.campaigns.find(p => parseInt(p.id) === id);
    }
    return null;

  },
}
